import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Wrapper } from 'modules/theme';
import SettingsSidebar from '../../sidebar';
import { Alert, confirm } from 'modules/theme';
import APIManager from 'modules/common/apiManager';
import { BarItems } from 'modules/theme';
/* import {
  DataWrapperClass,
  InsightWrapper,
  QuestionsContainer
} from '../../styles'; */
import {
   InsightWrapper, 
   DataWrapperClass, 
   ButtonCommonTheme,
   ReportingDropdownMenu,
   } from 'modules/theme';
import { Modal } from 'react-bootstrap';
import { FiTrash2 } from 'react-icons/fi';
import { PerPage,superWiserAccess } from 'helpers/system-config';
import {
  ModalTrigger,
  Pagination,
  Button,
  FormControl,
  ActionButtons,
  Table,
  Label,
  Tip,
  DataWithLoader,
  FormGroup,
  ControlLabel,
  ReportPagination,
  SeachForm,
  Spinner,
  ReportFilterHeaderTheme,
  CommonFilter
} from 'modules/theme';
import { leftSidebarType, modalType } from '../../../../../helpers/dotenv';
import { Icon } from 'modules/theme';
import { SidebarList } from 'modules/theme';
//import CommonFilter from './../../CommonFilter';
import { Row } from '../../Reporting/styles';
import { WrapperData } from 'modules/theme';
import { MdOutlineAdd } from 'react-icons/md';
import { ManageColumns } from 'modules/theme';
import { getStickyAgent, getUser } from '../../../../common/utils/api';
import { globalStateSelector } from 'store/selector';
import { connect } from 'react-redux';
var uuid = require('uuid');


const defaultColums = [
  'PhoneNumber',
  'duration',
  'hungupCause',
  'status',
  'data'
];

export class REPORT extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.moduleName = `Inbound Missed`;
    this.moduleUrl = `voice-cdr-report/list`;
    let selectedColumList = defaultColums;
    this.state = {
      isActive: false,
      listData: [],
      listField: [],
      configList: [],
      loading: false,
      showHide: false,
      modalType: modalType,
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      search: '',
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
      Filters: {},
      selectedFilter: {},
      assetsUrl: "",
      // isToggle: false
      columnList: defaultColums,
      selectedColumList: selectedColumList,
      customerColumn: {},
      showColumn: false,
      isDownload: false,
      user: [],
      // stickyAgent: [],
    };
    this.bindThis();
  }
  bindThis() {
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.getReportName = this.getReportName.bind(this);
    this.getData = this.getData.bind(this);
    this.getSelectedColumnNames = this.getSelectedColumnNames.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.downloadReport = this.downloadReport.bind(this);
    this.open = this.open.bind(this);
    this.handleModalShowColumn = this.handleModalShowColumn.bind(this);
    this.getFilter = this.getFilter.bind(this);
    this.onCustomColumnClick = this.onCustomColumnClick.bind(this);
  }
  componentDidMount() {
    this.getList();
  }

  async getFilter() {
    let userList = await getUser("", 100, 1);
    // let stickyAgentList = await getStickyAgent("", 100, 1);
    // console.log("campaignList", campaignList);
    this.setState({ "user": userList });
    // this.setState({ "stickyAgent": stickyAgentList });
  }

  open() {
    if (this.state.isActive) {
      this.setState({ isActive: false });
    } else {
      this.setState({ isActive: true });
    }
  }

  openModal() {
    this.setState({ showHide: true });
  }

  closeModal() {
    this.setState({ showHide: false });
  }

  getReportName() {
    return 'default';
  }

  handleModalShowColumn() {
    this.setState({ showColumn: !this.state.showColumn });
  }

  getSelectedColumnNames() {
    console.log(this.state.selectedColumList);
    return this.state.selectedColumList;
  }

  downloadReport(page = 1, perPage = '', filter = '') {
    var that = this;
    // this.setState({ loading: true });
    this.setState({ isDownload: true });

    filter = filter || {};
    perPage = perPage || this.state.perPageCount;

    let tData = {
      // limit: perPage,
      page_no: page,
      orderBy: '',
      order: '',
      type: 'voice',
      subType: 'missedCall',
      listConfig: this.state.customerColumn || {},
      ...filter
    }
    this.mAPI.sendPostAPI(
      `voice-cdr-report/export/reports`,
      tData,
      data => {
        this.setState({ isDownload: false });
        //console.log(JSON.stringify(data, null, 2));
        if (data.status === 'pending') {
          Alert.success(`You can download Report from Import & Export...`);
        } else {
          this.mAPI.downloadUrl(data.fileurl);
          let a = document.createElement('a');
          a.href = data.fileurl;
          a.download = data.csvfileName;
          a.click();
        }

      },
      (error, data) => {
        this.setState({ isDownload: false });
        console.log(`Error:`, error);
        Alert.error('Error');
      }
    );
  }

  columnProcess(columnList) {
    let result = {
      selected: [],
      total: [],
    }
    if (columnList) {
      columnList.map((column, key) => {
        column = column || {};
        key = column && column.varibleName ? column.varibleName : key;
        if (key) {
          let field = {
            "name": key,
            _id: uuid.v4(),
            checked: column.isDefault ? true : false,
            ...column,
          };
          result.total.push(field)
          if (column.isDefault) {
            result.selected.push(key)
          }
        }
      })
    }
    return result;
  }

  getData(data) {
    console.log(data);
    let selectedUser = [];
    // let selectedStickyAgent = [];
    if (data.selectedUser && data.selectedUser.length > 0) {
      data.selectedUser.map((element) => {
        if (element.value) {
          selectedUser.push(element.value);
        }
      })
    }
    let filter = {
      filter : data
    }

    let tempData = {};

    for (let item in data) {
      if (Array.isArray(data[item])) {
        tempData = {
          ...tempData,
          [item]: data[item].map((element) => element.value || element),
        };
      } else {
        tempData = {
          ...tempData,
          [item]: data[item],
        }
      }
    }

    this.setState({ "Filters": filter, "currentPage": 1 })
    this.getList(1, this.state.perPageCount, {filter:tempData})
    // this.downloadReport(1, this.state.perPageCount, filter)
  }

  getList(page = 1, perPage = '', filter = '') {
    var that = this;
    this.setState({ loading: true });

    console.log(filter);

    filter = filter || {};
    perPage = perPage || this.state.perPageCount;
    let tData = {
      limit: perPage,
      page_no: page,
      orderBy: '',
      order: '',
      type: 'voice',
      subType: 'missedCall',
      listConfig: this.state.customerColumn || {},
      ...filter
    };
    this.mAPI.sendPostAPI(
      this.moduleUrl,
      tData,
      data => {
        that.setState({ loading: false });
        if (data && data.data) {
          let result = this.columnProcess(data.configList);
          console.log('result', result);
          that.setState({
            assetsUrl: data.assetsUrl,
            listData: data.data,
            listField: data.configList,
            total: data.count || 0,
            SelectedList: [],
            selectedColumList: result.selected,
            columnList: result.total
          });
        } else {
          that.setState({ listData: [] });
        }
      },
      (error, data) => {
        that.setState({ loading: false });
        console.log(`Error:`, error);
        Alert.error('Error');
      }
    );
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map(listData => (listData.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter(e => e.selected)
    });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map(user => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    //To Control Master Checkbox State
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter(e => e.selected).length;
    // Update State
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter(e => e.selected)
    });
  }

  onPaginationChange(page) {
    console.log('onPaginationChange', page);
    this.setState({ currentPage: page });
    this.getList(page, this.state.perPageCount, this.state.Filters);
  }

  onPerPageChooser(perPage) {
    console.log('onPerPageChooser', perPage);
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getList(1, perPage, this.state.Filters);
  }

  remove(array, key, value) {
    const index = array.findIndex(obj => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  renderCharts() {
    return null;
  }

  onChange() { }

  onSingleChange(e, company) { }

  renderContent() {
    const { brands, history, queryParams } = this.props;
    return (
      <InsightWrapper>
         <ReportFilterHeaderTheme filterCloseOnClick={() => {
          if (this.state.isActive) {
            this.setState({ isActive: false });
          } else {
            // this.setState({ isActive: true });
          }
        }} />
        <CommonFilter
          filterList={["renderFrom",'renderDisposition', "renderTo", "renderStickyAgent", "renderTeam", "renderMissedReason", "renderTimezones"]}
          reportType='cdr'
          getSelectedColumnNames={this.getSelectedColumnNames}
          getData={this.getData}
          history={history}
          brands={[]}
          queryParams={[]}
          selectedFilter={this.state.selectedFilter}
          selectedValues={this.state.selectedValues}

          setFilter={this.setFilter}
          updateFilter={this.updateFilter}
          UserList={this.state.user}
          // StickyAgentList={this.state.stickyAgent}
        />
        {this.renderCharts()}
      </InsightWrapper>
    );
  }

  onCustomColumnClick(columnsConfig) {
    console.log("columnsConfig", columnsConfig)
    let _this = this;
    let customerColumn = {};
    if (columnsConfig) {
      columnsConfig.map((field) => {
        if (field.checked) {
          const result = _this.state.listField.filter(el => el.varibleName == field.name);
          console.log("columnsConfig result", result, field);
          if (result && result[0]) {
            let column = Object.assign({}, result[0]);
            console.log('column', column);
            column.lable = field.label || field.name;
            column.isDefault = field.isDefault;
            column.varibleName = field.label || field.name;
            customerColumn[column.varibleName] = column
            console.log('customerColumn[column.column]', customerColumn[column.column]);
          }
        }
      })
    }
    this.setState({ currentPage: 1 });
    console.log('customerColumn', customerColumn);
    this.setState({ "customerColumn": customerColumn, showHide: false, currentPage: 1 }, () => {
      _this.getList(1, _this.state.perPageCount, _this.state.Filters);
    });
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __('Reports'), link: '/reporting' },
      { title: __('Missed'), link: '/reporting/missed' }
    ];

    let _this = this;
    const mainContent = (
      <div>
        <Table bordered hover>
          <thead>
            <tr>
              {this.state.listField.map(column => {
                return column.isDefault === true ? (<th>{column.label}</th>) : "";
              }
              )}
            </tr>
          </thead>
          <tbody id="Report">
            {_this.state.listData.map(tData => {
              return (
                <tr >
                  {
                    _this.state.listField.map(column => {
                      if (column.isDefault === true) {
                        //console.log('tData[column.column]', tData[column.varibleName])
                        let result = tData[column.varibleName];
                        if (typeof result != "string" && typeof result != "number") {
                          if (typeof result == "object") {
                            try {
                              result = JSON.stringify(result);
                            } catch (error) {

                            }
                          } else if(typeof result == "boolean"){
                            result = result == true ? 'True':'False'
                          } else {  
                            result = "-";
                          }
                        }
                        return (
                          <td style={{ "overflow": "hidden", "textOverflow": "ellipsis", "maxWidth": "186px" }} >
                            <Tip text={result} >
                              <span>{result}</span>
                            </Tip>
                          </td>
                        )
                      } else {
                        return "";
                      }
                    })
                  }
                </tr>
              )
            })}
          </tbody>
        </Table>
        {/* </Row> */}
      </div>
    );

   /*  const editColumns = (
      <Button style={{display:"none"}}btnStyle="simple" size="small">
        Edit columns
      </Button>
    ); */

    const EditColumns = ({ onClick }) => {
      console.log('typeProps', onClick);
      return (
        <ButtonCommonTheme type="editColumns" editColumnsOnClick={onClick} />
      )
    }

    let { currentUser } = this.props;
    const actionBarRight = (
      <BarItems>
        {!(superWiserAccess.includes(currentUser.role)) && 
        
        <ModalTrigger
          title="Choose which column you see"
          trigger={<EditColumns />}
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          modalType={this.state.modalType}
        >
          <ManageColumns
            contentType="cdrReport"
            config={this.state.selectedColumList}
            save={this.onCustomColumnClick}
            closeModal={this.closeModal}
            fields={this.state.columnList}
          />
        </ModalTrigger>
        }
        {/* <Button
          btnStyle="filter"
          size="small"
          onClick={() => this.open()}
        >
          <img src="/images/filter.png" style={{ width: '15px', marginRight: '5px' }} />Filters
        </Button> */}
         <ButtonCommonTheme type='filter' filterOnClick={() => this.open()} />
        {!(superWiserAccess.includes(currentUser.role)) && 
        <span>
        {this.state.total === 0 ? 
         <ButtonCommonTheme type="disableDownload" downloadOnClick={() =>
          this.downloadReport(1, "", this.state.Filters)} downloadState={this.state.isDownload} />
        /* <Button
          btnStyle="default"
          size="small"
          disabled="true"
          style={{ padding: '9px 12px', width: '94px', color: '#ffffff' }}
          onClick={() =>
            this.downloadReport(1, "", this.state.Filters)
          }
        >
          {this.state.isDownload ? (
            <Spinner style={{ height: '2px', width: '2px', marginTop: '-15px', padding: '10px', marginBottom: '10px' }} />
          ) : (
            'Download'
          )}
        </Button> */ 
        : 
        <ButtonCommonTheme type='download' downloadOnClick={() =>
          this.downloadReport(1, "", this.state.Filters)
        } downloadState={this.state.isDownload} />
        /* <Button
          btnStyle="default"
          size="small"
          style={{ padding: '9px 12px', width: '94px' }}
          onClick={() =>
            this.downloadReport(1, "", this.state.Filters)
          }
        >
          {this.state.isDownload ? (
            <Spinner style={{ height: '2px', width: '2px', marginTop: '-15px', padding: '10px', marginBottom: '10px' }} />
          ) : (
            'Download'
          )}
        </Button> */
        }
        </span>
        }
      </BarItems>
    );

    return (
      <div className='heightClass'>
        <DataWrapperClass>
          {this.state.isActive && this.renderContent()}
         {/*  {this.state.isActive && <WrapperData content={this.renderContent()} overflow={true} />} */}

         <span className={this.state.isActive ? "addClass" : "removeClass"} onClick={() => {
            if (this.state.isActive) {
              this.setState({ isActive: false });
            } else {
              // this.setState({ isActive: true });
            }
          }}>
            <Wrapper
              header={<Wrapper.Header breadcrumb={breadcrumb} />}
              heading={<ControlLabel>{`Break`}</ControlLabel>}
              actionBar={
                <Wrapper.ActionBar
                  left={
                    <div>
                      {/* <ControlLabel>{`${this.moduleName} (${this.state.total || 0})`}</ControlLabel> */}

                    </div>
                  }
                  right={actionBarRight}
                />
              }
              footer={
                <ReportPagination
                  count={this.state.total}
                  onPaginationChange={this.onPaginationChange}
                  onPerPageChooser={this.onPerPageChooser}
                  currentPage={this.state.currentPage}
                  perPage={this.state.perPageCount}
                />
              }
              leftSidebar={<ReportingDropdownMenu />}
              showLeftSideBar={true}
              content={
                <div>
                  <DataWithLoader
                    data={mainContent}
                    loading={this.state.loading}
                    size={this.state.listData.length}
                    count={this.state.listData.length}
                    emptyText=""
                    emptyImage="/images/empty/no_report.png"
                  />
                </div>
              }
            />
          </span>
        </DataWrapperClass>
      </div>
    );
  }
}

const stateToProps = state => ({
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' })
});

const dispatchToProps = dispatch => ({
  dynamicUpdate: data => {
    // dispatch(globalAction.dynamicUpdate({ data }));
  }
});

REPORT.contextTypes = {
__: PropTypes.func
};

export default REPORT; //connect(stateToProps, dispatchToProps)(REPORT);  



// WEBPACK FOOTER //
// src/modules/screens/reporting/Inbound/components/Report.js